export default "__VITE_ASSET__524cc844__"